// extracted by mini-css-extract-plugin
module.exports =  {"tab":"_9330de7794--tab--dfUe7","tab__item":"_9330de7794--tab__item--Pv2Qb","tab__description":"_9330de7794--tab__description--ZeoWb"};